import { render, staticRenderFns } from "./rights-issue-subscription.vue?vue&type=template&id=19f8ed78&scoped=true"
import script from "./rights-issue-subscription.vue?vue&type=script&lang=js"
export * from "./rights-issue-subscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f8ed78",
  null
  
)

/* custom blocks */
import block0 from "./locale/rights-issue-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Frights-issue-subscription.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/rights-issue-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Frights-issue-subscription.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,FeaturesGridTwo: require('/vercel/path0/components/FeaturesGridTwo.vue').default,TwoColumnBlock: require('/vercel/path0/components/blocks/TwoColumnBlock.vue').default,DownloadCard: require('/vercel/path0/components/DownloadCard.vue').default})
